var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h1',[_vm._v("商品分类")])]),_c('el-tree',{attrs:{"default-expand-all":"","data":_vm.cateTree}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }